import React from 'react';
import LoginForm from '../../features/auth/components/LoginForm';

const LoginPage: React.FC = () => {
  return <LoginForm />;
};

export default LoginPage;
